/** Escape text before it goes into banner HTML (titles and descriptions accept HTML). */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Only http(s) and site-relative URLs may be linked; anything else becomes '#'. */
export function safeUrl(value: string): string {
  const trimmed = value.trim();
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('/')) return escapeHtml(trimmed);
  return '#';
}
